var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPayor = function SvgPayor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3464 5C18.3979 4.99991 18.4485 5.00771 18.4978 5.01953C18.6111 5.04621 18.7189 5.10222 18.8073 5.19043C18.9341 5.31723 18.9976 5.48403 18.9978 5.65039V16.5508C18.9977 16.9097 18.7063 17.2002 18.3474 17.2002C17.9886 17.2001 17.698 16.9096 17.6979 16.5508V7.21973L6.10811 18.8096C5.85426 19.0634 5.44202 19.0634 5.18818 18.8096C4.93483 18.5557 4.9345 18.1433 5.18818 17.8896L16.7751 6.30274L7.46943 6.32129C7.11059 6.32183 6.81878 6.03173 6.81807 5.67285C6.81762 5.31408 7.10865 5.02218 7.46748 5.02149L18.3464 5Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPayor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "payor.308dd4909f388a12ff1eb0d56d633f84.svg";